import { useState, useEffect, useRef } from "react";
import { createModel } from "hox";
import { enquiryService } from "../../dtpService";
import { IDtpTabEnum, ISupplierPriceDialog, IDtpMaterialDetail, IDtpDetail, ISupplierOfferDetails, ISupplierMaterialDetails, examineFields } from "../../dtpTypes";
import { IMaterialDetail } from "@/views/base/material/materialService";
import { message } from "antd";
import useGlobalModel from "@/model/globalModel";
import { useLockFn } from "ahooks";
import { convertRes2Blob } from "@/utils/exportFile";
import { momentFormat } from "@/utils/utils";
import moment from "moment";


export const useDtpDetailModel = createModel(function () {
    const { user: { shopCode, shopName }, setLoadingInfo } = useGlobalModel(({ user }) => [user])
    const initFormVal = {
        id: "",
        code: "",
        shopName
    };
    const [tabActive, setTabActive] = useState<IDtpTabEnum>(IDtpTabEnum.BASE_DETAIL) //tabs 选中

    //编辑缓存
    const [editFormVal, setEditFormVal] = useState<IDtpDetail>(initFormVal);
    const [editList, setEditList] = useState<IDtpMaterialDetail[]>([]);

    //新增缓存
    const [addFormVal, setAddFormVal] = useState<IDtpDetail>(initFormVal);
    const [addList, setAddList] = useState<IDtpMaterialDetail[]>([]);

    //添加商品弹框
    const [materialDialog, setMaterialDialog] = useState<boolean>(false);

    //重置页面缓存
    const resetPageCache = (mode: string) => {
        if (mode === "edit") {
            setEditFormVal(initFormVal);
            setEditList([]);
        }
        else if (mode === "add") {
            setAddFormVal(initFormVal);
            setAddList([]);
        }
        setTabActive(IDtpTabEnum.BASE_DETAIL);
    }

    //主单修改
    const updateFormVal = (mode: string, val?: object | null) => {
        const setFormVal = mode === "edit" ? setEditFormVal : setAddFormVal;
        setFormVal((origin: any) => val ? { ...origin, ...val } : initFormVal);
    }

    //商品子表修改
    const updateList = (mode: string, val: IDtpMaterialDetail[]) => {
        const setList = mode === "edit" ? setEditList : setAddList;
        setList([...val]);
    }

    //商品子表添加
    const insertMaterial = (mode: string, arr: IMaterialDetail[]) => {
        const setList = mode === "edit" ? setEditList : setAddList;
        setList(origin => {
            let newArr: IDtpMaterialDetail[] = [...origin];
            arr.forEach(material => {
                //选中的是否存在列表
                let isExist = origin.find(item => item.materialCode == material.code);
                if (!isExist) {
                    newArr.push({
                        "key": material.id,  //自己用
                        "materialId": material.id, // "物料id",
                        "materialCode": material.code, // "物料编号",
                        "replaceCode": material.replaceCode, // "替换号",
                        "materialName": material.name, // "物料名称",
                        "materialEname": material.nameEn, // "物料名称",
                        "typeCode": material.typeCode, // "物料类型",
                        "typeName": material.typeName, // "物料类型名称",
                        "num": material.num, // "询价数量",
                        "model": material.model, // "规格",
                        "note": "", // "备注"
                    })
                }
            });
            return newArr;
        });
        setMaterialDialog(false);
    }

    //商品子表删除
    const removeMaterial = (mode: string, selectedRowKeys: string[]) => {
        const setList = mode === "edit" ? setEditList : setAddList;
        setList(origin => origin.filter(item => selectedRowKeys.indexOf(item.key) < 0));
    }

    //获取一条数据
    const getDtpDetailOne = async (id: string) => {
        let { retData } = await enquiryService.one(id);
        let { details, consignTime, createTime, updateTime, ...formVal } = retData;
        if (retData) {
            setEditFormVal({
                ...formVal,
                consignTime: consignTime ? moment(consignTime) : null,
                //createTime: momentFormat(createTime),
                //updateTime: momentFormat(updateTime)
                //createTime:moment(createTime),
                //updateTime:moment(createTime)
                createTime: retData.createTime ? moment(retData.createTime) : "",
                updateTime: retData.updateTime ? moment(retData.updateTime) : "",
            });
            setEditList(details?.map(item => ({ ...item, key: item.id ?? "" })) ?? []);
        }
        return retData;
    };

    //报价单新增 | 编辑
    const insertOrUpdateDtp = useLockFn(async (mode: string, formVal: IDtpDetail) => {
        const materialList = mode === "edit" ? editList : addList;
        const formV = mode === "edit" ? editFormVal : addFormVal;
        let data = {
            ...formVal,
            ...formV,
            ...editFormVal,
            consignTime: momentFormat(formV?.consignTime as any),
            //createTime: momentFormat(formVal?.createTime as any),
            //updateTime: momentFormat(formVal?.updateTime as any),
            createTime: formVal.createTime instanceof Object ? formVal.createTime.format('YYYY-MM-DDTHH:mm:ss') : null,
            updateTime: formVal?.updateTime ? moment(formVal.updateTime).format('YYYY-MM-DDTHH:mm:ss') : undefined,
            shopCode,
            //customerCode:'',
            // details: materialList
        };
        //新增
        if (mode === "edit") {
            delete data.updateUser
            let updateVo = {
                ...data,
                id: editFormVal.id,
                code: editFormVal.code ?? "",
                customerCode: editFormVal.customerCode ?? '',
                consignTime: editFormVal?.consignTime ? moment(editFormVal.consignTime).format('YYYY-MM-DDTHH:mm:ss') : undefined,
            }

            let { retData } = await enquiryService.update(updateVo);
            getDtpDetailOne(editFormVal.code)
            message.success("保存成功")
            return retData;
        } else {
            let { retData } = await enquiryService.insert(data);
            message.success("新增成功,自动转换至编辑详情页")
            return retData;
        }
    })

    //导出
    const exportDtp = async () => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" });
        try {
            // let result = await enquiryService.detailExport(editFormVal.code, shopCode);
            // result && setLoadingInfo({ loadingVisible: false, txt: "" });
            // convertRes2Blob(result);
        } catch { setLoadingInfo({ loadingVisible: false, txt: "" }) }
    }

    //报价单明细下载模板
    const downloadTpl = async () => {
        let result = await enquiryService.downloadTpl();
        convertRes2Blob(result);
    }
    //生成
    const transportGenerate = async (code: string) => {
        let { retData } = await enquiryService.generate(code);
        message.success("单据生成成功");
        return retData;

    }
    //提交审核
    const transportSave = async (code: string) => {
        let { retData } = await enquiryService.submit(code);
        message.success("提交审核成功");
        return retData;

    }
    // 总经理审批
    const transportManger = async (params: examineFields) => {
        let { retData } = await enquiryService.manger(params);
        // message.success("总经理审批成功");
        return retData;
    }
    // 总监审批
    const transportExamineManger = async (params: examineFields) => {
        let { retData } = await enquiryService.examineManager(params);
        // message.success("总监审批成功");
        return retData;
    }
    return {
        /***field***/
        editFormVal,
        editList,
        addFormVal,
        addList,
        tabActive, setTabActive,
        materialDialog, setMaterialDialog,
        /***method***/
        getDtpDetailOne,
        updateFormVal,
        updateList,
        removeMaterial,
        insertMaterial,
        insertOrUpdateDtp,
        resetPageCache,
        exportDtp,
        downloadTpl,
        transportGenerate,
        transportSave,
        transportManger,
        transportExamineManger
    }
});